import { createAction, props } from '@ngrx/store';
import { IProject } from '@app/models/project';

export enum ProjectsActionTypes {
    GetProjects = '[PROJECTS] Get Projects',
    ProjectsLoaded = '[PROJECTS] Load success',
    GetFilteredProjects = '[PROJECTS] Get Filtered Projects',
    FilteredProjectsLoaded = '[PROJECTS] Load Filtered success',
    BeginCreateProject = '[PROJECTS] Begin create project',
    SuccessCreateProject = '[PROJECTS] Success create project',
    BeginDeleteProject = '[PROJECTS] Begin delete project',
    SuccessDeleteProject = '[PROJECTS] Success delete project',
    BeginCloneProject = '[PROJECTS] Begin clone project',
    SuccessCloneProject = '[PROJECTS] Success clone project',
    BeginUploadImage = '[PROJECTS] Begin upload image',
    SuccessUploadImage = '[PROJECTS] Success upload image',
    BeginUpdateProject = '[PROJECTS] Begin update project',
    SuccessUpdateProject = '[PROJECTS] Success update project',
    BeginUpdateLastUsedProject = '[PROJECTS] Begin update last used project',
    SuccessUpdateLastUsedProject = '[PROJECTS] Success update last used project',
    BeginGetSelectedProject = '[PROJECTS] Begin get selected project',
    SuccessGetSelectedProject = '[PROJECTS] Success get selected project',
    ErrorProjects = '[PROJECTS] Error',
}

export const GetProjectsAction = createAction(
    ProjectsActionTypes.GetProjects
);

export const ProjectsLoadedAction = createAction(
    ProjectsActionTypes.ProjectsLoaded,
    props<{ payload }>()
);

export const GetFilteredProjectsAction = createAction(
    ProjectsActionTypes.GetFilteredProjects,
    props<{ payload: string }>()
);

export const FilteredProjectsLoadedAction = createAction(
    ProjectsActionTypes.FilteredProjectsLoaded,
    props<{ payload }>()
);


export const BeginCreateProjectAction = createAction(
    ProjectsActionTypes.BeginCreateProject,
    props<{ payload: IProject }>()
);

export const SuccessCreateProjectAction = createAction(
    ProjectsActionTypes.SuccessCreateProject,
    props<{ payload: IProject }>()
);

export const BeginDeleteProjectAction = createAction(
    ProjectsActionTypes.BeginDeleteProject,
    props<{ payload: string }>()
);

export const SuccessDeleteProjectAction = createAction(
    ProjectsActionTypes.SuccessDeleteProject,
    props<{ payload }>()
);

export const BeginGetSelectedProjectAction = createAction(
    ProjectsActionTypes.BeginGetSelectedProject,
    props<{ payload: string }>()
);

export const SuccessGetSelectedProjectAction = createAction(
    ProjectsActionTypes.SuccessGetSelectedProject,
    props<{ payload }>()
);

export const BeginUpdateProjectAction = createAction(
  ProjectsActionTypes.BeginUpdateProject,
  props<{ payload: IProject }>()
);

export const SuccessUpdateProjectAction = createAction(
  ProjectsActionTypes.SuccessUpdateProject,
  props<{ payload }>()
);

export const BeginUploadImageAction = createAction(
  ProjectsActionTypes.BeginUploadImage,
  props<{ payload: { files: any[], projectId: string, fieldTechName: string} }>()
);

export const SuccessUploadImageAction = createAction(
  ProjectsActionTypes.SuccessUploadImage,
  props<{ payload }>()
);

export const BeginUpdateLastUsedProjectAction = createAction(
  ProjectsActionTypes.BeginUpdateLastUsedProject,
  props<{ payload: IProject }>()
);

export const SuccessUpdateLastUsedProjectAction = createAction(
  ProjectsActionTypes.SuccessUpdateLastUsedProject,
  props<{ payload }>()
);

export const BeginCloneProjectAction = createAction(
  ProjectsActionTypes.BeginCloneProject,
  props<{ payload: {  projectId: string, newProjectName: string } }>()
);

export const SuccessCloneProjectAction = createAction(
  ProjectsActionTypes.SuccessCloneProject,
  props<{ payload }>()
);

export const ErrorProjectsAction = createAction(
    ProjectsActionTypes.ErrorProjects, props<Error>()
);
